import { useQuery } from '@tanstack/react-query';
import { useStore } from "../appStore";
import axios from "axios";
import { StorageKeys, getFromLocalStorage, saveToLocalStorage } from '../localStorageHelper';

const key = 'location';

const getLocation = async (parentId, id) => {

    const response = await axios
        .get(`api/Organization/${parentId}/Locations/${id}`);
    return response?.data;
}

const useLocationQuery = ({ locationId, enable }) => {
    const orgId = useStore((state) => state.CurrentOrganizationId);
    const cacheKey = StorageKeys.LOCATION(locationId);

    return useQuery({
        queryKey: ['location', locationId],
        enabled: enable,
        queryFn: async () => {
            // Check for cached data
            const cached = getFromLocalStorage(cacheKey);
            if (cached) return cached;

            // Otherwise fetch fresh
            const data = await getLocation(orgId, locationId);
            saveToLocalStorage(cacheKey, data); // save to localStorage
            return data;
        },
    });
};

export { useLocationQuery, key };
